import {SuggestAction} from '@yandex-delivery/api/model/suggest'
import type {SuggestService} from '@yandex-delivery/api/service/suggest'
import type {PreOrderRetrieveResponse} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/api/pre-order'

import type {SourcePoint} from '../../../../types'
import {SourcePointDeliveryMethod} from '../../../../types'
import {fromPinDropToPointAddress} from '../../../../utils'
import {toSuggestLocation} from '../mappers/to-suggest-location'

export const fetchSourcePoint = async (
  {fetchAddressSuggest}: SuggestService,
  preOrderRetrieve: PreOrderRetrieveResponse,
): Promise<SourcePoint | undefined> => {
  const sourcePoint = preOrderRetrieve.claim.route_points?.filter(point => point.type === 'source')[0]

  if (!sourcePoint) return

  const addressSuggest = await fetchAddressSuggest({
    point: toSuggestLocation(sourcePoint.address.coordinates),
    type: 'a',
    location: toSuggestLocation(sourcePoint.address.coordinates),
    action: SuggestAction.PIN_DROP,
  })

  return {
    _type: 'source',
    _deliveryMethod: SourcePointDeliveryMethod.Station,
    dropOffPoint: {},
    cashOnDelivery: false,
    _id: sourcePoint.point_id,
    _visitOrder: sourcePoint.visit_order,
    externalID: '',
    contact: sourcePoint.contact,
    address: fromPinDropToPointAddress(addressSuggest) ?? {},
  }
}
